import { motion, useMotionValue, useTransform } from "framer-motion";
import ActivityIcon from "./IconMap";

export default function SwipeCard({ activity, onDecision, isTop, index }) {
  const x = useMotionValue(0);
  const rotate = useTransform(x, [-200, 0, 200], [-14, 0, 14]);
  const likeOpacity = useTransform(x, [40, 140], [0, 1]);
  const nopeOpacity = useTransform(x, [-140, -40], [1, 0]);

  const handleDragEnd = (_, info) => {
    if (info.offset.x > 120) onDecision("like");
    else if (info.offset.x < -120) onDecision("dislike");
  };

  return (
    <motion.div
      data-testid={`swipe-card-${activity.id}`}
      className="absolute inset-0 select-none"
      style={{ x, rotate, zIndex: 100 - index }}
      drag={isTop ? "x" : false}
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.7}
      onDragEnd={handleDragEnd}
      initial={{ scale: 0.9, y: 24, opacity: 0 }}
      animate={{ scale: isTop ? 1 : 0.94, y: isTop ? 0 : 16, opacity: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 28 }}
      whileTap={{ cursor: "grabbing" }}
    >
      <div
        className="nb-card h-full w-full flex flex-col items-center justify-center text-center p-8 overflow-hidden relative"
        style={{ backgroundColor: activity.color }}
      >
        {/* stamps */}
        <motion.div
          style={{ opacity: likeOpacity }}
          className="absolute top-8 left-6 -rotate-12 border-4 border-black rounded-xl px-4 py-1 bg-white"
        >
          <span className="font-heading text-3xl font-bold text-green-600">LOVE IT</span>
        </motion.div>
        <motion.div
          style={{ opacity: nopeOpacity }}
          className="absolute top-8 right-6 rotate-12 border-4 border-black rounded-xl px-4 py-1 bg-white"
        >
          <span className="font-heading text-3xl font-bold text-brand-primary">NOPE</span>
        </motion.div>

        <div className={`flex flex-col items-center transition-opacity ${isTop ? "opacity-100" : "opacity-0"}`}>
          <div className="bg-white border-2 border-black rounded-2xl p-6 shadow-nb-sm mb-6">
            <ActivityIcon name={activity.icon} className="w-16 h-16 text-black" strokeWidth={2.2} />
          </div>
          <span className="nb-badge bg-white mb-4">{activity.category}</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-black mb-3">{activity.title}</h2>
          <p className="text-base md:text-lg font-semibold text-black/80 max-w-xs">{activity.description}</p>
        </div>
      </div>
    </motion.div>
  );
}
